/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FlightObservedPrice } from './FlightObservedPrice';
import {
    FlightObservedPriceFromJSON,
    FlightObservedPriceFromJSONTyped,
    FlightObservedPriceToJSON,
    FlightObservedPriceToJSONTyped,
} from './FlightObservedPrice';
import type { FlightObservedItinerary } from './FlightObservedItinerary';
import {
    FlightObservedItineraryFromJSON,
    FlightObservedItineraryFromJSONTyped,
    FlightObservedItineraryToJSON,
    FlightObservedItineraryToJSONTyped,
} from './FlightObservedItinerary';
import type { FlightPassengerComposition } from './FlightPassengerComposition';
import {
    FlightPassengerCompositionFromJSON,
    FlightPassengerCompositionFromJSONTyped,
    FlightPassengerCompositionToJSON,
    FlightPassengerCompositionToJSONTyped,
} from './FlightPassengerComposition';
import type { FlightObservedFare } from './FlightObservedFare';
import {
    FlightObservedFareFromJSON,
    FlightObservedFareFromJSONTyped,
    FlightObservedFareToJSON,
    FlightObservedFareToJSONTyped,
} from './FlightObservedFare';

/**
 * Versioned immutable evidence for the discovery result selected by the caller. Supplier capabilities, native offer identifiers, and matcher assertions are deliberately absent.
 * @export
 * @interface FlightSelectedObservation
 */
export interface FlightSelectedObservation {
    /**
     *
     * @type {number}
     * @memberof FlightSelectedObservation
     */
    schemaVersion: FlightSelectedObservationSchemaVersionEnum;
    /**
     *
     * @type {string}
     * @memberof FlightSelectedObservation
     */
    sourceProvider: FlightSelectedObservationSourceProviderEnum;
    /**
     *
     * @type {string}
     * @memberof FlightSelectedObservation
     */
    sourceUrl?: string | null;
    /**
     *
     * @type {string}
     * @memberof FlightSelectedObservation
     */
    sourceAirline?: string | null;
    /**
     *
     * @type {FlightObservedItinerary}
     * @memberof FlightSelectedObservation
     */
    itinerary: FlightObservedItinerary;
    /**
     *
     * @type {FlightObservedFare}
     * @memberof FlightSelectedObservation
     */
    fare: FlightObservedFare;
    /**
     *
     * @type {FlightObservedPrice}
     * @memberof FlightSelectedObservation
     */
    price: FlightObservedPrice;
    /**
     *
     * @type {FlightPassengerComposition}
     * @memberof FlightSelectedObservation
     */
    passengers: FlightPassengerComposition;
    /**
     *
     * @type {string}
     * @memberof FlightSelectedObservation
     */
    pointOfSale: string;
}


/**
 * @export
 */
export const FlightSelectedObservationSchemaVersionEnum = {
    NUMBER_1: 1
} as const;
export type FlightSelectedObservationSchemaVersionEnum = typeof FlightSelectedObservationSchemaVersionEnum[keyof typeof FlightSelectedObservationSchemaVersionEnum];

/**
 * @export
 */
export const FlightSelectedObservationSourceProviderEnum = {
    GoogleFlights: 'google_flights',
    Planner: 'planner',
    GoMcp: 'go_mcp'
} as const;
export type FlightSelectedObservationSourceProviderEnum = typeof FlightSelectedObservationSourceProviderEnum[keyof typeof FlightSelectedObservationSourceProviderEnum];


/**
 * Check if a given object implements the FlightSelectedObservation interface.
 */
export function instanceOfFlightSelectedObservation(value: object): value is FlightSelectedObservation {
    if (!('schemaVersion' in value) || value['schemaVersion'] === undefined) return false;
    if (!('sourceProvider' in value) || value['sourceProvider'] === undefined) return false;
    if (!('itinerary' in value) || value['itinerary'] === undefined) return false;
    if (!('fare' in value) || value['fare'] === undefined) return false;
    if (!('price' in value) || value['price'] === undefined) return false;
    if (!('passengers' in value) || value['passengers'] === undefined) return false;
    if (!('pointOfSale' in value) || value['pointOfSale'] === undefined) return false;
    return true;
}

export function FlightSelectedObservationFromJSON(json: any): FlightSelectedObservation {
    return FlightSelectedObservationFromJSONTyped(json, false);
}

export function FlightSelectedObservationFromJSONTyped(json: any, ignoreDiscriminator: boolean): FlightSelectedObservation {
    if (json == null) {
        return json;
    }
    return {

        'schemaVersion': json['schema_version'],
        'sourceProvider': json['source_provider'],
        'sourceUrl': json['source_url'] == null ? undefined : json['source_url'],
        'sourceAirline': json['source_airline'] == null ? undefined : json['source_airline'],
        'itinerary': FlightObservedItineraryFromJSON(json['itinerary']),
        'fare': FlightObservedFareFromJSON(json['fare']),
        'price': FlightObservedPriceFromJSON(json['price']),
        'passengers': FlightPassengerCompositionFromJSON(json['passengers']),
        'pointOfSale': json['point_of_sale'],
    };
}

export function FlightSelectedObservationToJSON(json: any): FlightSelectedObservation {
    return FlightSelectedObservationToJSONTyped(json, false);
}

export function FlightSelectedObservationToJSONTyped(value?: FlightSelectedObservation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {

        'schema_version': value['schemaVersion'],
        'source_provider': value['sourceProvider'],
        'source_url': value['sourceUrl'],
        'source_airline': value['sourceAirline'],
        'itinerary': FlightObservedItineraryToJSON(value['itinerary']),
        'fare': FlightObservedFareToJSON(value['fare']),
        'price': FlightObservedPriceToJSON(value['price']),
        'passengers': FlightPassengerCompositionToJSON(value['passengers']),
        'point_of_sale': value['pointOfSale'],
    };
}
